import ReactDOM from 'react-dom/client';
import { AuthProvider } from './hooks/useAuth';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import App from './App';
import { ThemeProvider } from './components/ThemeProvider';
import './index.css';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <QueryClientProvider client={queryClient}>
        <ThemeProvider attribute="class" defaultTheme="dark" enableSystem disableTransitionOnChange>
            <AuthProvider>
                <App />
            </AuthProvider>
        </ThemeProvider>
    </QueryClientProvider>
);
